<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="confs.filters">
				<el-form-item v-for="item in confs.query">
					<el-input v-if="item.elType=='el-input'" v-model="confs.filters[item.key]" :placeholder="item.title" @change="getLists"></el-input>
					<el-select v-else-if="item.elType=='el-select'" filterable 
						v-model="confs.filters[item.key]" :placeholder="item.title" class="h-m-select">
						<el-option v-for="selectItem in confs.selectList[item.listkey].data" 
							:key="selectItem[item.opkey]" :label="selectItem[item.opval]" 
							:value="selectItem[item.opkey]">
						</el-option>
					</el-select>					
					<el-date-picker v-else-if="item.elType=='el-date-picker'" 
						v-model="confs.filters[item.key]" value-format="yyyy-MM-dd"
						:width="100" type="date" :placeholder="item.title"
					   />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-document-add" @click="queryBtnClick">上传XLS退订数据</el-button>
				</el-form-item>
				<el-form-item>
					上传excel:手机号码,订购时间，退订时间
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="500">
			<el-table-column label="操作" width="270" v-if="!confs.isOpCol">
				<template slot-scope="scope">
					<el-row>
						<el-button type="danger" v-if="scope.row.status==2" icon="el-icon-delete" circle size="mini" @click="handleDel(scope.$index, scope.row)"></el-button>
						<el-button type="primary" v-if="scope.row.status==2" size="mini" @click="handleDown(scope.$index, scope.row)">下载同步xls</el-button>
						<el-button type="primary" v-if="scope.row.status==2" size="mini" @click="handleDownAll(scope.$index, scope.row)">下载平台源</el-button>
					</el-row>
				</template>
			</el-table-column>
			<el-table-column label="" width="110" v-if="confs.hasTableBtn">
				<template slot-scope="scope">
					<el-row>
						<el-button type="primary" size="mini" @click="tableBtnClick(scope.$index, scope.row)">{{confs.tableBtn.name}}</el-button>
					</el-row>
				</template>
			</el-table-column>
			<el-table-column v-for="item in confs.tables" :prop="item.prop" :label="item.label" :width="item.minWidth">
				<template slot-scope="scope">
					<div v-if="item.showLab">{{showLabs(scope.row[item.prop],item.listkey,item.opkey,item.opval)}}</div>
					<div v-else-if="item.showLabStr">
						<div v-for="labItem in item.showLabStrs">
							<div v-if="labItem.showLab">
								{{labItem.qz}}
								{{showLabs(scope.row[labItem.key],labItem.listkey,labItem.opkey,labItem.opval)}}
							</div>
							<div v-else>{{labItem.qz}}{{scope.row[labItem.key]}}</div>
						</div>
					</div>
					<div v-else-if="item.isBtn">
						<el-button type="success" plain  round size="mini" @click="btnClickRow(scope.row,item)">{{item.btnName}}</el-button>
					</div>
					<div v-else>{{scope.row[item.prop]}}</div>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条翻页-->
		<el-col :span="21" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-drawer
		  :title="editformtitle"
		  :visible.sync="editFormVisible" :before-close="clickClose"
		  size="50%" :with-header="false"
		  direction="rtl">
			<el-form :model="confs.editForm" label-width="100px" :rules="confs.formRules" ref="confs.editForm" label-width="180px">
				<el-container style="min-height: 100vh;">
					<el-header style="position: fixed; top: 0; width: 100%; z-index: 1024;">
					  <!-- 头部内容 -->			  
					  <div>
						{{editformtitle}}
					  </div>
					</el-header>
					<el-main style="padding: 30px;">
						<el-form-item v-if="errmsg">
							<font color="red">{{errmsg}}</font>
						</el-form-item>
						<el-form-item v-for="item in confs.edits" :label="item.title" :prop="item.prop">
							<el-input v-if="item.elType=='el-input'" v-model="confs.editForm[item.key]" :placeholder="item.title" @change="blurCheck(item.key)"></el-input>
							<el-input v-else-if="item.elType=='textarea'" type="textarea" :rows="item.rows" v-model="confs.editForm[item.key]" :placeholder="item.title"></el-input>
							<el-select v-else-if="item.elType=='el-select'" filterable 
								v-model="confs.editForm[item.key]" :placeholder="item.title" class="h-m-select">
								<el-option v-for="selectItem in confs.selectList[item.listkey].data" 
									:key="selectItem[item.opkey]" :label="selectItem[item.opval]" 
									:value="selectItem[item.opkey]">
								</el-option>
							</el-select>
						</el-form-item>
					</el-main>
					<el-footer>
						<div class="to-right">
							<el-button @click.native="editFormVisible = false">取消</el-button>
							<el-button type="primary" @click.native="editSubmit" :loading="editLoading">保存</el-button>
						  </div>
					</el-footer>
				</el-container>
			</el-form>
		</el-drawer>
		
		<!-- 上传文件 -->
		<el-drawer
		  :visible.sync="addLoadFileVisble" :before-close="closeAddFile"
		  size="40%" direction="rtl">
			<el-container style="min-height: 100vh;">
				<el-main style="padding: 20px;">
					<el-upload
					  class="upload-demo"
					  drag
					  :action="fileServerPath"
					  :on-success="handleSuccess"
					  multiple>
					  <i class="el-icon-upload"></i>
					  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					  <div class="el-upload__tip" slot="tip">只能上传cvs且不超过500kb</div>
					</el-upload>
				</el-main>
			</el-container>
		</el-drawer>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				errmsg:'',
				testStr:'',
				cfids:'',
				confs:{},
				datalist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				///上传文件
				addLoadFileVisble:false,
				fileServerPath:''
			}
		},
		methods: {
			blurCheck:function(checkName){
				//console.log("检测:"+checkName);
				try{
					this.errmsg = "";
					let checkJson = this.confs.submitChecks[checkName];
					let para = {
						actionurl:checkJson.actionurl,
						sqlid:checkJson.checkSql
					};
					try{
						let paramCheckJs = checkJson.param;
						for (let i = 0; i < paramCheckJs.length; i++) {
							//console.log(paramCheckJs[i].valkey+"="+this.confs.editForm[paramCheckJs[i].valkey]);
							if(this.confs.editForm[paramCheckJs[i].valkey]!=""){
								para[paramCheckJs[i].key] = this.confs.editForm[paramCheckJs[i].valkey] ;
							}
						}
						//paramCheckJs.forEach(function(item) {
						//	console.log(item.valkey+"="+this.confs.editForm[item.valkey]);
						//	if(this.confs.editForm[item.valkey]!=""){
						//		para[item.key] = this.confs.editForm[item.valkey] ;
						//	}
						//});
					}catch(e){
						console.log("错误:"+e);
					}
					getListPage(para).then((res) => {
						if(res.data.total>0) {
							this.errmsg = checkJson.msgTip;
						}
						//this.$message({message: res.data.message,type: "success"});
					});
				}catch(e){}
			},
			closeAddFile:function(){
				this.addLoadFileVisble = false;
			},
			queryBtnClick:function(){
				try{
					this.addLoadFileVisble = true ;
					this.fileServerPath = "/api/control/addFile?type=tdMobile";
				}catch(e){}
				
			},
			handleDown:function(index, row){
				//下载...
				let paras = "api/control/createXls?pc="+row.pc;
				console.log(paras);
				window.open(paras);
			},
			handleDownAll:function(index, row){
				//下载...
				let paras = "api/control/createXlsAll?pc="+row.pc;
				console.log(paras);
				window.open(paras);
			},
			handleSuccess(response, file, fileList) {
			  // response 是从服务器返回的数据
			  // file 是上传的文件对象
			  // fileList 是上传组件的文件列表数组
			  console.log('上传成功', response);
			  this.$message.success('上传成功！');
			  this.getLists();
			  // 在这里你可以处理上传成功后的逻辑，例如更新数据列表等
			},
			tableBtnClick:function(index,row){
				try{
					if(this.confs.tableBtn.type=='uploadfile'){
						this.addLoadFileVisble = true ;
						this.fileServerPath = "/api/datas/addFile?id="+row.id+"&scode="+row.scode+"&ps="+row.process_class;
						return ;
					}
				}catch(e){}
				try{
					let para = {
						actionurl:this.confs.tableBtn.url
					};
					try{
						let paramCheckJs = this.confs.tableBtn.param;
						paramCheckJs.forEach(function(item) {
							
							para[item.key] = row[item.valkey] ;
							//console.log(item.valkey+"=="+row[item.valkey]);
						});
					}catch(e){
						console.log("错误:"+e);
					}
					getListPage(para).then((res) => {
						this.$message({message: res.data.message,type: "success"});
					});
				}catch(e){}				
			},
			btnClickRow:function(rows,colItem){
				this.$router.push(colItem.goUrl+"id="+rows.id);
			},
			cleanQuery:function(){
				for(let item of this.confs.query){
					this.confs.filters[item.key] = '';
				}
			},
			isObject:function(value) {
			  return typeof value === 'object' && value !== null;
			},
			clickClose:function(){},
			showLabs:function(keystr,listkey,opkey,opval){
				let reStr = '';
				if(!this.isObject(this.confs.selectList[listkey])) return keystr;
				if(!this.isObject(this.confs.selectList[listkey].data)) return keystr;
				for (var item of this.confs.selectList[listkey].data) {
					//console.log(item[opkey]+'='+item[opval]+','+keystr);
					if(item[opkey]==keystr) {
						reStr = item[opval];
						break ;
					}
				}
				return reStr ;
			},
			getConf:function(){
				let para = {actionurl:'default/getCfs','sqlid':'getcf',id:this.cfids};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.confs = res.data.confs;
						if(this.confs.isdebug){
							console.log("confs.tables="+this.confs.tables.length);
						}
						//初始化时间
						try{
							if(this.isObject(this.confs.initTimes)){
								for (let i = 0; i < this.confs.initTimes.length; i++) {
									this.confs.filters[this.confs.initTimes[i]] = util.formatDate.getdatestr(-1, 'yyyy-MM-dd');
								}
							}
						}catch(ee){}
						/////////////
						if(this.isObject(this.confs.selectList)){
							for (let [key, value] of Object.entries(this.confs.selectList)) {
								//console.log("key="+key+",,,"+value);
								this.getLabList(key,value);
							}
						}
						//准备获取list
						this.getLists();
					}
					this.listLoading = false;
				});
			},
			getLabList:function(keyName,objJson){
				let para = {actionurl:objJson.acturl,sqlid:objJson.sqlid,code:objJson.code};
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.confs.selectList[keyName].data = res.data.datas;
						console.log(this.confs.selectList[keyName].data);
					}
					//this.listLoading = false;
				});
			},
			getLists:function(){
				let para = Object.assign({}, this.confs.filters);
				para.page = this.page;
				para.pagesize = this.pagesize;
				para.actionurl='default/getList';
				para.sqlid=this.confs.sqls.query;
				
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleCurrentChange:function(val){
				this.page = val;
				this.getLists();
			},
			handleAdd:function(){
				if(this.confs.isdebug){
					console.log("新增");
				}
				this.editFormVisible = true;
				this.editformtitle = '新增';
				for (var key in this.confs.editForm) {
					this.confs.editForm[key]='';
				}
				this.confs.editForm.actionurl = 'default/save';
				this.confs.editForm.sqlid = this.confs.sqls.add
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				for (let [key, value] of Object.entries(row)) {
					if(this.isObject(value)) {
						this.confs.editForm[key] = JSON.stringify(value);
					}else {
						this.confs.editForm[key] = value;
					}
				}
				//this.confs.editForm = Object.assign({}, row);
				//console.log('handleEdit>>'+this.editForm.shop_code);
				this.confs.editForm.actionurl = 'default/save';//设置Sqlid
				this.confs.editForm.sqlid = this.confs.sqls.upt;
			},
			editSubmit:function(){
				if(this.errmsg!=""){
					this.$message({message: "有错误数据存在,请先处理!",type: "error"});
					return ;
				}
				let para = Object.assign({}, this.confs.editForm);
				util.saveByFormFunction(this,'confs.editForm',para);
			},
			isObjectExists:function(obj) {
			  return typeof obj !== 'undefined' && obj !== null;
			},
			handleDel: function (index, row) {
				console.log(row);
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					this.listLoading = true;
					if(this.isObjectExists(this.confs.delcheck)){
						let checkPara = {
							actionurl:this.confs.delcheck.actionurl,
							sqlid:this.confs.delcheck.checkSql
						};
						try{
							let paramCheckJs = this.confs.delcheck.param;
							paramCheckJs.forEach(function(item) {
								checkPara[item.key] = row[item.valkey] ;
								//console.log(item.valkey+"=="+row[item.valkey]);
							});
						}catch(e){
							console.log("错误:"+e);
						}
						getListPage(checkPara).then((res) => {
							if(!util.checkLogOut(this,res.data)){
								if(res.data.total>0) {
									this.$message({message: "此记录被使用，暂不可删除!",type: "error"});
								}
								else {
									this.$message({message: "此记录未被使用，正在删除中!",type: "success"});
									let para = {
										actionurl:'default/del',
										sqlid:this.confs.sqls.del,
										id:row.id
									};
									delData(para).then((res) => {
										this.listLoading = false;
										this.$message({message: res.data.message,type: res.data.type});
										this.getLists();
									});
								}
							}
							this.listLoading = false;
						});
					}else{
						let para = {
							actionurl:'default/del',
							sqlid:this.confs.sqls.del,
							id:row.id
						};
						delData(para).then((res) => {
							this.listLoading = false;
							this.$message({message: res.data.message,type: res.data.type});
							this.getLists();
						});
					}
				}).catch(() => {});
			}
		},
		mounted() { 
			this.cfids = 'zT9d6RBg';
			this.getConf();
		}
	}	
</script>
<style scoped>
	.el-header {
	  background-color:#eceef3;
	  color: #409eff;
	  padding-left:50px;
	  text-align: left;
	  line-height: 60px;
	}
	.el-footer{
		padding-top:10px;
		position:absolute;
		bottom:0;
		width:100%;
		background:#f7f9fd;
		color:white;
	}
	.to-right{
		position: fixed;
		right: 20px;
	}
	.el-main {
	  margin-top: 60px; /* 头部高度 */
	  padding: 0px;
	  margin-right:20px;
	  margin-bottom:40px;
	}
	.box-card-edit{
		height:500px;
	}
</style>


// WEBPACK FOOTER //
// queryStatus.vue?ffb69bbc